import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import moment from 'moment'
dayjs.extend(utc);
dayjs.extend(timezone);

export default {
  methods: {
    /**
     * localのタイムゾーン取得
     */
    getTimeZone() {
      return dayjs.tz.guess()
    },
    /**
     * 日時をIsoformatへ補正
     * @param {string} datetime
     */
    adjustIsoformat(datetime) {
      return dayjs(datetime).format('YYYY-MM-DDTHH:mm:ssZ')
    },
    /**
     * タイムゾーン変換
     * @param {string} datetime
     * @param {string} tz
     */
    convertTimezone(datetime, tz) {
      let ret = dayjs(datetime).tz(tz).format()
      if (tz == 'UTC') {
        // Pythonのdatetimeクラスで扱える形式に変換
        ret = ret.replace("Z", "+00:00" );
      }
      return ret
    },
    /**
     * local時刻へ変換(タイムゾーン考慮)
     * @param {string} datetime
     */
    toLocalTime(datetime) {
      let ret = ""
      if (datetime) {
        ret = this.toLocalTimeFormat(datetime, 'YYYY-MM-DD HH:mm:ss')
      }
      return ret
    },
    /**
     * local時刻へ変換(タイムゾーン考慮)
     * @param {string} datetime
     */
    toLocalDate(datetime) {
      let ret = ""
      if (datetime) {
        ret = this.toLocalTimeFormat(datetime, 'YYYY-MM-DD')
      }
      return ret
    },
    /**
     * local時刻へ変換(タイムゾーン考慮)
     * @param {string} datetime
     * @param {string} format
     */
    toLocalTimeFormat(datetime, format) {
      let ret = ""
      if (datetime) {
        ret = this.adjustIsoformat(datetime)
        const tz = this.getTimeZone()
        ret = this.convertTimezone(ret, tz)
        ret = dayjs(ret).format(format)
      }
      return ret
    },
    /**
     * サーバー時刻へ変換(タイムゾーン考慮)
     * @param {string} datetime
     */
    toServerTime(datetime) {
      let ret = ""
      if (datetime) {
        ret = this.adjustIsoformat(datetime)
        const tz = process.env.VUE_APP_SERVER_TIME_ZONE
        ret = this.convertTimezone(ret, tz)
      }
      return ret
    },

    /**
     * 日付範囲から日付のArrayを返品する
     * @param {startdate} string 
     * @param {enddate} string 
     * @returns Array of dates
     */
    dateArrayFromRange({
      startDate, endDate
    }) {
      let dateArray = [];
      let currentDate = dayjs(startDate);
      const stopDate = dayjs(endDate);
      while (currentDate <= stopDate) {
          dateArray.push( dayjs(currentDate).format('YYYY-MM-DD') )
          currentDate = dayjs(currentDate).add(1, 'days');
      }
      return dateArray;
    },

    /**
     * Get week of Month
     */
    weekOfMonth(date) {
      return moment(date).week() - moment(date).startOf('month').week() + 1
    },

    getISOWeekInMonth(date) {
      // Copy date so don't affect original
      var d = new Date(+date);
      if (isNaN(d)) return;
      // Move to previous Monday
      d.setDate(d.getDate() - d.getDay() + 1);
      // Week number is ceil date/7
      return {month: +d.getMonth()+1, week: Math.ceil(d.getDate()/7)};
    }
  },
}
